import { render, staticRenderFns } from "./edit-item-dialog.vue?vue&type=template&id=3895f226&scoped=true&"
import script from "./edit-item-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-item-dialog.vue?vue&type=style&index=0&id=3895f226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895f226",
  null
  
)

export default component.exports